import React, { Component } from "react";
import PropTypes from "prop-types";
import { Container } from "../../../components/atoms/Container";
import { Section } from "../../../components/atoms/Section";
import GuidesPosts from "../../../components/atoms/GuidesPosts";
import BreadCrumbBar from "../../../components/atoms/BreadCrumbBar";
import { GUIDES_TAB_BAR_SLUG, GUIDES_TAB_HEADER_COLOR, GUIDES_TITLE_NAME } from "../../../helpers/constants";
import gpdWomanTable from "../../../assets/images/guides/GPD_woman_table_left.png";
import GuidesHeader from "../../../components/molecules/GuidesHeader";
import urlPatterns from "../../../urls";
import { header } from "../../../styles/variables";
import GuidesTabNavigator from "../../../components/molecules/GuidesTabNavigator";

class GuidesTabTasting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showBreadCrumbBar: true,
    };
  }

  async componentDidMount() {
    const { match, history, location } = this.props;
    const { params } = match || {};
    const { slug } = params || {};
    if (slug) {
      const { search } = location || {};
      history.push({
        pathname: urlPatterns.GUIDE_TASTING_POST(slug),
        search,
      });
    }
  }

  render() {
    const { history, location } = this.props;

    const { showBreadCrumbBar } = this.state;

    return (
      <>
        <GuidesHeader
          headerIcon={gpdWomanTable}
          headerColor={GUIDES_TAB_HEADER_COLOR.GUIDE_TASTING}
          headerTitle={GUIDES_TITLE_NAME.GUIDE_TASTING}
          headerDescription="Taste like an expert!"
        />
        <GuidesTabNavigator
          mobileHeaderStyleTop={header.mobileHeight}
          shouldDisappearOnMobile
          backgroundColor={GUIDES_TAB_HEADER_COLOR.GUIDE_TASTING}
          urlTasting={urlPatterns.GUIDE_TASTING}
          location={location}
        />
        <Section xxs>
          {showBreadCrumbBar && (
            <BreadCrumbBar homeLabel="Guides" parentLabel="Tasting Guides" location={location} />
          )}
          <Container>
            <GuidesPosts
              history={history}
              filters={`${GUIDES_TAB_BAR_SLUG.GUIDE_TASTING}`}
              metaTitle="Wine For Beginners: The #1 Wine Tasting Guide | Good Pair Days"
              isFromTabTasting
              location={location}
            />
          </Container>
        </Section>
      </>
    );
  }
}

GuidesTabTasting.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  match: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default GuidesTabTasting;
